import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import Tooltip from 'scoreboard/components/tooltip'
import highlight from 'scoreboard/components/highlight'
import template from 'scoreboard/components/cascade-tooltip.hbs'

var CascadeToolip = Backbone.View.extend({

	initialize: function(options) {
		this.options = options || {}
		this.options.attachTo.on('mouseenter', () => this.createTooltip())
		this.options.attachTo.on('mouseleave', () => this.removeTooltip())
	},

	createTooltip() {
		this.tooltip && this.tooltip.remove()
		var descendants = highlight(i18n.get('common.descendants'))
		var context = _.extend({
			cascadeHelpKey: this.options.helpKey,
			descendants: descendants
		})
		var content = template(context)

		this.tooltip = new Tooltip({
			attachTo: this.options.attachTo,
			content: content,
			placement: 'above',
			arrow: 'center',
			extraClass: 'cascade-tooltip'
		}).render()
	},

	removeTooltip() {
		this.tooltip && this.tooltip.remove()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.tooltip], 'remove')
	}

})

export default CascadeToolip

CascadeToolip.__filename__ = 'components/cascade-tooltip.js'
